// FilterReset.tsx
import React, {useContext} from 'react';
import {IconButton, Tooltip} from '@mui/material';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import ZeiterfassungDashboardContext from '../../../../../Contexts/ZeiterfassungDashboardContext/ZeiterfassungDashboardContext';

function FilterReset() {
  const {resetFilters, filter} = useContext(ZeiterfassungDashboardContext);

  // Check if any filters are active
  const isAnyFilterActive = filter.department || filter.user || filter.bauvorhaben;

  return (
    <Tooltip title='Filter zurücksetzen'>
      <span>
        <IconButton
          onClick={resetFilters}
          disabled={!isAnyFilterActive}
          sx={{
            m: 1,
            color: isAnyFilterActive ? 'error.main' : 'action.disabled',
          }}>
          <FilterAltOffIcon />
        </IconButton>
      </span>
    </Tooltip>
  );
}

export default React.memo(FilterReset);
